export const CREDIT_UNIT_SCALE = 4;

export function unitsToCredits(units: number) {
	return units / CREDIT_UNIT_SCALE;
}

export function formatCredits(units: number) {
	const credits = unitsToCredits(units);
	return Number.isInteger(credits) ? String(credits) : credits.toFixed(2).replace(/\.?0+$/, "");
}
